import React from 'react'
import { Link } from 'react-router-dom'

type SpeakToKitLogoProps = {
    to?: string
    href?: string
    className?: string
    ariaLabel?: string
}

const baseClassName = 'flex items-center gap-1 cursor-pointer'

const SpeakToKitLogo = ({
    to,
    href,
    className = '',
    ariaLabel = 'Speak To Kit home',
}: SpeakToKitLogoProps): React.JSX.Element => {
    const finalClassName = className
        ? `${baseClassName} ${className}`.trim()
        : baseClassName

    const content = (
        <>
            <span className="font-sans font-medium text-xl tracking-tight text-foreground">
                Speak To
            </span>
            <span className="font-script text-3xl text-primary font-bold relative top-1">
                Kit
            </span>
        </>
    )

    if (to) {
        return (
            <Link to={to} className={finalClassName} aria-label={ariaLabel}>
                {content}
            </Link>
        )
    }

    if (href) {
        return (
            <a
                href={href}
                className={finalClassName}
                aria-label={ariaLabel}
                rel="noreferrer"
            >
                {content}
            </a>
        )
    }

    return (
        <span className={finalClassName} aria-label={ariaLabel}>
            {content}
        </span>
    )
}

export default SpeakToKitLogo
